import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.jpeg'
import _imports_1 from '../assets/download-on-the-app-store.svg'


const _withScopeId = n => (_pushScopeId("data-v-45c010e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  alt: "CyrusLyrics logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Welcome to CyrusLyrics!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "app-store-link",
    target: "_blank",
    href: "https://apps.apple.com/us/app/cyruslyrics/id1613010334"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "app-store-image",
      alt: "Download CyrusLyrics on the App Store",
      src: _imports_1
    })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " CyrusLyrics is an iOS app to help you quickly store, find, and add the lyrics of songs that you like to sing. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Watch the following YouTube video to learn about how to use the app.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "yt-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "560",
    height: "820",
    src: "https://www.youtube.com/embed/videoseries?list=PLWXp2X5PBDOmFd1kqyYsPtYwdgXIfDZT3",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  })
], -1))
const _hoisted_8 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_8))
}